import React, { useEffect, useState } from "react";
import { FileSignature } from "lucide-react";
import { api } from "@/lib/api";
import { formatDeShort } from "@/lib/date";

/** Manager/Master-Kachel: Weiterbildungs-Teilnehmer deren Anwesenheit noch nicht unterschrieben ist. */
export default function PendingSignaturesWidget() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/weiterbildung/attendance/pending-signatures").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);

  if (rows === null) return null;

  return (
    <div className="border border-slate-200 bg-white p-5" data-testid="pending-signatures-widget">
      <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-overline text-slate-500">
        <FileSignature size={12} strokeWidth={1.5} /> Weiterbildung
      </div>
      <div className="font-heading text-xl font-light tracking-tighter text-slate-900 mt-1 mb-3">
        Noch nicht unterschriebene Anwesenheit
      </div>
      {rows.length === 0 ? (
        <div className="text-sm text-slate-400 italic py-2" data-testid="pending-signatures-empty">
          Alles unterschrieben — keine offenen Anwesenheitslisten.
        </div>
      ) : (
        <div className="divide-y divide-slate-100 max-h-80 overflow-y-auto" data-testid="pending-signatures-list">
          {rows.map((r, i) => (
            <div key={i} className="flex items-center justify-between py-2 text-sm" data-testid={`pending-signature-row-${i}`}>
              <div>
                <div className="text-slate-900 font-medium">{r.participant_name}</div>
                <div className="text-xs text-slate-500">{r.class_name} · {formatDeShort(r.date)}</div>
              </div>
              <span className="text-[10px] font-bold uppercase tracking-overline text-amber-700 bg-amber-50 border border-amber-200 px-2 py-1">
                offen
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
